import React from 'react';

/**
 * Month-over-month growth row rendered beneath a chart.
 *
 * Shared by BROSOverviewChart and the P&L ComposedChart so
 * the display cannot diverge. Each caller computes its own
 * growthRowData array; this component owns only the rendering.
 *
 * Props destructured in body (babel-metadata-plugin workaround).
 */
function MoMGrowthRow(props) {
  const { growthRowData, growthLabel } = props;
  if (!growthRowData || growthRowData.length === 0) return null;
  return (
    <div className="mt-2 border-t pt-1.5" data-testid="overview-chart-growth-row">
      <div className="flex items-center">
        <span className="text-[10px] text-muted-foreground shrink-0 w-14 text-right pr-2">
          {growthLabel ?? 'MoM'}
        </span>
        <div className="flex flex-1 min-w-0">
          {growthRowData.map(function (d, i) {
            return (
              <div key={d.monthKey ?? i} className="flex-1 text-center text-[10px] font-mono">
                {d.MoMGrowth == null ? (
                  <span className="text-muted-foreground/50">-</span>
                ) : (
                  <span className={d.MoMGrowth >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}>
                    {d.MoMGrowth >= 0 ? '+' : ''}{Math.round(d.MoMGrowth)}%
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export { MoMGrowthRow };
